export const SPECIAL_PRICE_FILTER_TITLE = 'Filtrar precios especiales:'

export const SPECIAL_PRICE_FILTER_SEARCH_PLACEHOLDER = 'Buscar por cliente o producto'

export const SPECIAL_PRICE_FILTER_NOTE =
  'En este módulo podrás asignar precios unicos a ciertos productos, asignados a Clientes con Atributos en especifico.'

export const SPECIAL_PRICE_FILTER_DATE_LABEL = 'FECHA'

export const SPECIAL_PRICE_FILTER_VARIANTS = {
  DEFAULT: 'default',
  GROUPED: 'grouped'
}

export const SPECIAL_PRICE_FILTER_ORDER = [
  'client_attribute',
  'product',
  'sales_unit',
  'status'
]

export const SPECIAL_PRICE_FILTER_CONFIG = [
  {
    key: 'client_attribute',
    title: 'CLIENTE/ATRIBUTO',
    variant: SPECIAL_PRICE_FILTER_VARIANTS.GROUPED,
    widthClassName: 'special-price-filters__item special-price-filters__item--client-attribute',
    dropdownWidth: 320
  },
  {
    key: 'product',
    title: 'PRODUCTO',
    variant: SPECIAL_PRICE_FILTER_VARIANTS.DEFAULT,
    widthClassName: 'special-price-filters__item special-price-filters__item--product',
    dropdownWidth: 320
  },
  {
    key: 'sales_unit',
    title: 'UNIDAD DE VENTA',
    variant: SPECIAL_PRICE_FILTER_VARIANTS.DEFAULT,
    widthClassName: 'special-price-filters__item special-price-filters__item--sales-unit',
    dropdownWidth: 280
  },
  {
    key: 'status',
    title: 'ESTADO',
    variant: SPECIAL_PRICE_FILTER_VARIANTS.DEFAULT,
    widthClassName: 'special-price-filters__item special-price-filters__item--status',
    dropdownWidth: 240
  }
]

const SPECIAL_PRICE_FILTER_CONFIG_BY_KEY = SPECIAL_PRICE_FILTER_CONFIG.reduce(
  (configByKey, filterConfig) => ({
    ...configByKey,
    [filterConfig.key]: filterConfig
  }),
  {}
)

export const SPECIAL_PRICE_ORDERED_FILTER_CONFIG = SPECIAL_PRICE_FILTER_ORDER
  .map((filterKey) => SPECIAL_PRICE_FILTER_CONFIG_BY_KEY[filterKey])
  .filter(Boolean)
